import { render, staticRenderFns } from "./OneTaxSwitcherComponent.vue?vue&type=template&id=54c6a643&lang=pug&"
import script from "./OneTaxSwitcherComponent.vue?vue&type=script&lang=ts&"
export * from "./OneTaxSwitcherComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.8_vd7qwssw5i3h3fjzjs5bz4d2ha/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports